import React from 'react';
import { TextField, SimpleShowLayout, Show } from 'react-admin';
import AmountField from '../../components/fields/AmountField';

export const styles = {
	aside: {
		minWidth: '25em',
		marginLeft: '1em'
	},
	inlineBlock: {
		display: 'inline-flex',
		marginRight: '1rem'
	}
};

const AccountingAccountItemShow = props => (
	<Show {...props}>
		<SimpleShowLayout>
			<TextField source="accountId" />
			<TextField source="accountItemStatus" />
			<TextField source="accountItemType" />
			<TextField source="transferId" />
			<AmountField source="amount" />
			<AmountField source="amountLC" />
			<AmountField source="balance" />
			<AmountField source="balanceLC" />
			<AmountField source="turnover" />
			<AmountField source="turnoverLC" />
			<AmountField source="openAmount" />
		</SimpleShowLayout>
	</Show>
);

export default AccountingAccountItemShow;
